import styled from "styled-components";

export const Container = styled.div`
  background-image: ${(props) => `url('${props.img}')`};
  background-size: cover;
  background-repeat: no-repeat;
  width: 157px;
  height: 217px;
  display: flex;
  flex-direction: column;
  align-items: start;
  border-radius: 16px;
  cursor: ${(props) => (props?.isActive ? "pointer" : "default")};
  z-index: 1;

  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */

  @media screen and (max-height: 700px) {
    width: 140px;
    height: 190px;
    margin-right: 16px;
  }

  @media screen and (min-width: 769px) {
    width: ${({ cardWidth }) => cardWidth ?? "325px"};
    height: 210px;
    border-radius: 24px;
  }
`;

export const ContainerColor = styled.div`
  position: relative;
  width: 157px;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  justify-content: space-between;
  padding: 8px;
  background-color: #fff;
  overflow: hidden;

  @media screen and (min-width: 769px) {
    width: ${({ cardWidth }) => cardWidth ?? "325px"};
    padding: 15px;
  }
`;

export const ContainerInner = styled.div`
  height: max-content;
  display: flex;
  border-radius: 16px;
  background-color: #fff;
  align-items: start;
  flex-direction: column;
  cursor: pointer;
  gap: 16px;
  overflow: hidden;
  padding: 2px;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
  white-space: nowrap;
`;

export const Title = styled.span`
  color: ${(props) => props.color || "#1F2D3D"};
  font-size: ${(props) => props.fontSize || "11px"};
  line-height: ${(props) => props.lineHeight || "13px"};
  font-weight: ${(props) => props.fontWeight || 700};
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  word-break: break-all;
  // width: calc(98%);

  @media screen and (max-height: 700px) {
    font-size: 10px;
  }

  @media screen and (min-width: 769px) {
    font-size: ${(props) => props.fontSize || "14px"};
    line-height: ${(props) => props.lineHeight || "19px"};
  }
`;

export const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LocationNameWrapper = styled.div`
  display: flex;
`;

export const ButtonCard = styled.button`
  min-width: 100%;
  height: 32px;
  font-weight: bold;
  font-size: 16px;
  padding: 0px;
  align-self: center;
  color: ${(props) => props.color || "#6A7481"};
  border: 1px solid #1f2d3d;
  border-radius: 16px;
  background-color: ${(props) =>
    props.backgroundColor || "rgba(106, 116, 129, 0)"};
  border-color: ${(props) => props.borderColor || "#6A7481"};

  @media screen and (max-height: 700px) {
    font-size: 12px;
  }

  @media screen and (min-width: 769px) {
    font-size: 16px;
    height: 44px;
    border-radius: 44px;
  }
`;

export const SwooshSVG = styled.img`
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  z-index: 1 !important;
  object-fit: cover;
`;

export const ImageBadgeCity = styled.img`
  width: 64px;
  height: 52px;
  filter: ${(props) => (props.grayScale ? "grayscale(1)" : "none")};

  @media screen and (min-width: 769px) {
    width: 80px;
    height: 65px;
  }
`;
